import CustomDrawer from "@/components/drawer";
import SearchBox from "@/components/searchBox";
import { MerchantServiceCategoryDto } from "@/models/club";
import AddCategory from "@/modules/schedule/addCategory";
import { Button, Divider, Group, Radio, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconPlus } from "@tabler/icons-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  openedCategory: boolean;
  closeCategory: () => void;
  value: string;
  setValue: (value: string) => void;
  categories: MerchantServiceCategoryDto[];
};

function SelectCategory({
  openedCategory,
  closeCategory,
  value,
  setValue,
  categories,
}: Props) {
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const [
    openedNewCategory,
    { open: openNewCategory, close: closeNewCategory },
  ] = useDisclosure(false);

  return (
    <>
      <CustomDrawer
        opened={openedCategory}
        close={closeCategory}
        onClose={closeCategory}
        position="bottom"
        custom="select-category"
        title="انتخاب دسته بندی"
        size="lg"
      >
        <Radio.Group
          value={value}
          onChange={(e) => {
            setValue(e);
            navigate(-1);
          }}
        >
          <SearchBox
            setSearch={setSearch}
            placeholder="جستجو دسته بندی"
            title=""
          />
          <Stack pt="md" gap="md">
            {categories
              ?.filter((category) => category?.title?.includes(search))
              ?.map((category) => (
                <Radio.Card
                  radius="md"
                  value={category?.id?.toString()}
                  key={category?.title}
                  withBorder={false}
                >
                  <Group wrap="nowrap" align="flex-start">
                    <Radio.Indicator />
                    <Text>{category.title}</Text>
                  </Group>
                </Radio.Card>
              ))}
          </Stack>
        </Radio.Group>
        <Stack py="md">
          <Divider />
        </Stack>
        <Button
          variant="subtle"
          onClick={openNewCategory}
          leftSection={<IconPlus />}
        >
          <Text fw="lighter">افزودن دسته بندی جدید</Text>
        </Button>
      </CustomDrawer>
      <CustomDrawer
        opened={openedNewCategory}
        close={closeNewCategory}
        onClose={closeNewCategory}
        position="bottom"
        custom="new-category"
      >
        <AddCategory />
      </CustomDrawer>
    </>
  );
}

export default SelectCategory;
